export default (wireModel) => ({
    wireModel,

    init() {
        const input = this.$el.querySelector('input');

        this.$watch('wireModel', () => {
            const value = parseInt(input.value);
            input.value = (isNaN(value) ? 0 : value).toString().padStart(3, '0');
        });
    },
});
